import { useS4LContext } from '@s4l/react-context'
import { useEffect, useRef } from 'react'

export const SearchExecuter = () => {
  const { domain } = useS4LContext()
  const hasUserInteracted = useRef(false)

  useEffect(() => {
    const onSearch = async () => {
      await domain.SearchFromPartialAndCriteriaPropertyUseCase.execute({
        hasUserInteracted: hasUserInteracted.current,
      })

      hasUserInteracted.current = true
    }

    domain.on('CreateSearchCriteriaPropertyUseCase', onSearch)
    domain.on('CreateSearchPropertyUseCase', onSearch)

    return () => {
      domain.off('CreateSearchCriteriaPropertyUseCase', onSearch)
      domain.off('CreateSearchPropertyUseCase', onSearch)
    }
  }, [domain])

  return null
}
SearchExecuter.displayName = 'SearchExecuter'

export default SearchExecuter
